import { apiService } from '../api/api-client';
import { RecallReportListItem, RecallReportDetail } from '@/types';
import { PaginatedResponse } from '@/types/common.types';

export interface RecallReportListParams {
  counterparty?: string;
  limit?: number;
  offset?: number;
}

export interface UpdateItemPayload {
  id: number;
  quantity: number;
  is_deleted?: boolean;
  counterparty_product_id?: string;
}

export interface CreateItemPayload {
  counterparty_product_id: string;
  symbol_id?: string;
  quantity: number;
}

export const recallReportService = {
  async getRecallReports(params?: RecallReportListParams): Promise<PaginatedResponse<RecallReportListItem>> {
    return apiService.get<PaginatedResponse<RecallReportListItem>>('/reports/recall/', { params });
  },

  async getRecallReportDetail(id: number): Promise<RecallReportDetail> {
    return apiService.get<RecallReportDetail>(`/reports/recall/${id}/`);
  },

  async downloadRecallReport(id: number): Promise<Blob> {
    return apiService.get<Blob>(`/reports/recall/${id}/download/`, {
      responseType: 'blob',
    });
  },

  async updateItems(reportId: number, updates: UpdateItemPayload[], create: CreateItemPayload[] = []): Promise<RecallReportDetail> {
    return apiService.patch<RecallReportDetail>(
      `/reports/recall/${reportId}/items/`,
      { updates, create }
    );
  },

  async resetReport(reportId: number): Promise<RecallReportDetail> {
    return apiService.post<RecallReportDetail>(
      `/reports/recall/${reportId}/reset/`
    );
  },

  async sendReport(reportId: number): Promise<RecallReportListItem> {
    return apiService.post<RecallReportListItem>(
      `/reports/recall/${reportId}/send/`
    );
  },
};
